<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [text]="backLabel" *ngIf="!isRequestedAsModal"></ion-back-button>
      <ion-button (click)="cancel()" *ngIf="isRequestedAsModal">
        <ims-icon slot="icon-only" name="close"></ims-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ pageTitle }}</ion-title>
  </ion-toolbar>
  <ion-progress-bar type="indeterminate" *ngIf="isRendering"></ion-progress-bar>
</ion-header>

<ion-content scrollY="false" scrollX="false">
  <!-- PDF.js -->
  <div #container id="container">
    <div #wrapper class="pdfWrapper">
      <canvas #thecanvas></canvas>
    </div>
  </div>
</ion-content>

<!-- PDF Features -->
<ion-footer>
  <ion-progress-bar type="indeterminate" *ngIf="isRendering"></ion-progress-bar>
  <ion-toolbar>
    <div class="viewer-controls">
      <ion-buttons>
        <ion-button (click)="pdfViewZoomOut()" color="primary" size="large" [disabled]="disableZoomOut">
          <ion-icon slot="icon-only" name="remove"></ion-icon>
        </ion-button>
        <ion-button (click)="pdfViewZoomIn()" color="primary" size="large" [disabled]="disableZoomIn">
          <ion-icon slot="icon-only" name="add"></ion-icon>
        </ion-button>
      </ion-buttons>
      <span class="divider"></span>
      <ion-buttons>
        <ion-button (click)="pdfViewPrevious()" color="primary" size="large" [disabled]="disablePreviousPage">
          <ion-icon slot="icon-only" name="chevron-up"></ion-icon>
        </ion-button>
        <span class="page-indicator">{{ curPageNum }} / {{ pageCount }}</span>
        <ion-button (click)="pdfViewNext()" color="primary" size="large" [disabled]="disableNextPage">
          <ion-icon slot="icon-only" name="chevron-down"></ion-icon>
        </ion-button>
      </ion-buttons>
    </div>
  </ion-toolbar>
</ion-footer>